









































import { Component, Vue, Watch } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import { archiveProduct } from '@/api/products'

@Component({
  name: 'ProductSummary',
  components: {}
})
export default class extends Vue {
  isLoading = false
  private created() {
    // Vue.$myGlobal = 'test'
    // console.log(Vue.$myGlobal)
  }
  private editProduct() {
    this.$router.push({ path: `/product/edit/${this.$route.params.id}` })
  }
  private async archiveThisProduct() {
    const id = parseInt(this.$route.params.id)
    if (!isNaN(id)) {
      try {
        const { data } = await archiveProduct(id)
        if (data.successful) {
          this.$router.push({ path: `/product/list` })
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.error(error)
      }
    }
  }
  // private chartOptions = {
  //   chart: {
  //     id: 'vuechart-example'
  //   },
  //   xaxis: {
  //     categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
  //   }
  // }
  // private series = [
  //   {
  //     name: 'series-1',
  //     data: [30, 40, 35, 50, 49, 60, 70, 91]
  //   }
  // ]
  private series = [
    {
      name: 'High - 2013',
      data: [28, 29, 33, 36, 32, 32, 33]
    },
    {
      name: 'Low - 2013',
      data: [12, 11, 14, 18, 17, 13, 13]
    }
  ]

  private chartOptions = {
    chart: {
      height: 350,
      type: 'line',
      id: 'vuechart-example',
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },
      toolbar: {
        show: false
      }
    },
    colors: ['#77B6EA', '#545454'],
    // dataLabels: {
    //   enabled: true
    // },
    stroke: {
      curve: 'smooth',
      width: 3
    },
    title: {
      text: 'Media',
      align: 'left',
      offsetY: 5,
      offsetX: 20
    },
    subtitle: {
      text: 'Statistics',
      offsetY: 25,
      offsetX: 20
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5
      }
    },
    markers: {
      size: 6,
      strokeWidth: 0,
      hover: {
        size: 9
      }
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
      title: {
        text: 'Month'
      }
    },
    yaxis: {
      title: {
        text: 'Temperature'
      },
      min: 5,
      max: 40
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5
    }
  }

  // private series: [
  //   {
  //     name: 'Music'
  //     data: [1, 15, 26, 20, 33, 27]
  //   },
  //   {
  //     name: 'Photos'
  //     data: [3, 33, 21, 42, 19, 32]
  //   },
  //   {
  //     name: 'Files'
  //     data: [0, 39, 52, 11, 29, 43]
  //   }
  // ]
  // private optionsLine = {
  //   chart: {
  //     height: 328,
  //     type: 'line',
  //     zoom: {
  //       enabled: false
  //     },
  //     dropShadow: {
  //       enabled: true,
  //       top: 3,
  //       left: 2,
  //       blur: 4,
  //       opacity: 1
  //     }
  //   },
  //   stroke: {
  //     curve: 'smooth',
  //     width: 2
  //   },
  //   //colors: ["#3F51B5", '#2196F3'],
  //   title: {
  //     text: 'Media',
  //     align: 'left',
  //     offsetY: 25,
  //     offsetX: 20
  //   },
  //   subtitle: {
  //     text: 'Statistics',
  //     offsetY: 55,
  //     offsetX: 20
  //   },
  //   markers: {
  //     size: 6,
  //     strokeWidth: 0,
  //     hover: {
  //       size: 9
  //     }
  //   },
  //   grid: {
  //     show: true,
  //     padding: {
  //       bottom: 0
  //     }
  //   },
  //   labels: ['01/15/2002', '01/16/2002', '01/17/2002', '01/18/2002', '01/19/2002', '01/20/2002'],
  //   xaxis: {
  //     tooltip: {
  //       enabled: false
  //     }
  //   },
  //   legend: {
  //     position: 'top',
  //     horizontalAlign: 'right',
  //     offsetY: -20
  //   }
  // }

  //var chartLine = new ApexCharts(document.querySelector('#line-adwords'), optionsLine);
  // chartLine.render();
}
